<div class="innerBanner">
    <div class="container md">
        <div class="viewerAssign">
            <div class="row">
                <div class="col-12 col-md-6">
                   <div class="">
                       <a href="javascript:void(0);" class="backLink"><b><img src="assets/images/icons/backarrow.png" /></b>BACK  TO COURSE DETAILS</a>
                   </div>
                   <div class="viewerModule">
                       <h2>Introduction to Motor Engine Rerouting</h2>
                       <div class="engineWrap">
                       <div class="joinerDetails mb-0">
                           <span class="joinerDetailsImage">
                               <img src="assets/images/icons/doughnut_chart.svg">
                            </span>
                            <div class="joinerContent">
                                <h3>15%</h3>
                                <div class="ghrapWrap mb-0">
                                    <span style="width: 15%;"></span>
                                </div>
                            </div>
                        </div>
                    </div>

                    </div>
                    <div class="viewerSubModule">
                        <div class="viewerSubTitle">
                            <span>SUB MODULE 2</span>
                            <h2>Beginner level Introduction to Barrel Engine</h2>
                        </div>
                        <div class="viewerModifyi">
                            <ul class="modifyIcons">
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/frame.svg" /></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                     
                </div>
                <div class="col-12 col-md-6">
    
                    <div class="timerWrap countdown">
                        <ul>
                            <li>
                                <div class="timer ">
                                    <span>01</span>
                                    <small>hrs</small>
                                </div>
                            </li>
                            <li>
                                <b>:</b>
                            </li>
                            <li>
                                <div class="timer">
                                    <span>10</span>
                                    <small>min</small>
                                </div>
                            </li>
                            <li>
                                <b>:</b>
                            </li>
                            <li>
                                <div class="timer">
                                    <span>34</span>
                                    <small>sec</small>
                                </div>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

 <div class="dynamicBookWrap">
<div class="container">
    <div class="row">
        <div class="resultWrap">
            <div class="resul_img">
                <img src="assets/images/thumb-down.png" />
            </div>
             <h5>You have failed this Assessment!</h5>
             <span class="divider red"></span>
             <p>You have no more attempts left to pass this assessment</p>
             <div class="btnWrap mb-3 pb-3">
                <a href="javascript:void(0);" class="btn btn-primary btn-sm btn-border" (click)="open(content)">
                    <span>Contact Admin</span>
                </a>
             </div>
        <div class="btnWrap">
            <a href="javascript:void(0);" [routerLink]="['/assigned_details_moudle']" class="backPage">Back to course details</a>
        </div>
        </div>
    </div>
</div>
</div>

<ng-template #content let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
              </button>
            <figure>
                <img src="assets/images/hourglass.png">
            </figure>
            <h6>Hold Tight!</h6>
            <p>Your request to increase the number of attempts available for assessments, has been sent to the administrator for review and approval.</p>
        
        <a href="javascript:void(0);" class="btn btn-primary btn-sm btn-border" (click)="modal.close('Close click')">
            <span>Close</span>
        </a>
    </div>
    </div>
  </ng-template>